function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//@ts-check
import React, { useState, useCallback, useMemo, useEffect, useContext } from 'react';
import { HStack, VStack, Pressable, Spinner, Box } from 'native-base';
import { Collapse, IconButton, TableCell, TableRow } from '@mui/material';
import { Badge, Typography, Iconography, logUserEvent, Button } from 'fmc-digital-common';
import { badgeStyle } from './StyleSheet';
import { TaskConstants } from '../../../constants';
import { DocumentTable } from '../DocTable';
import { useLipStore } from '../../../loaninprogress';
import { ESignContext, getToken } from '../../../loaninprogress/hooks/Esign';
import DocUploadTrackingSnackbar from '../DocUploadTrackingSnackbar';
import { isEmpty } from 'lodash';
export const MuiTableRow = ({
  taskTableData,
  bgColor,
  selectedCard,
  handleToggle,
  index
}) => {
  const {
    taskStatus,
    name,
    details,
    documentList,
    taskType,
    borrowerName,
    isWaitingforBorrowerESign,
    nonEsignedBorrowerNames,
    trackingItemName,
    status
  } = taskTableData;
  const {
    TASK_TYPE_TRACKING_ITEM,
    FILES_NONE,
    TASK_STATUS_COMPLETED,
    TASK_TYPE_SIGN_DISCLOSURES,
    ACTIONS_UPLOAD,
    ACTIONS_SIGN_DISCLOSURES,
    WAITING_FOR_TEXT,
    noFilesUploaded,
    TASK_UPLOAD_ERROR_CORRECTION_NEEDED,
    TASK_UPLOAD_ERROR_PRE_GATE_INCOMPLETE,
    TASK_UPLOAD_ERROR_PROBLEM
  } = TaskConstants;
  const isOpen = selectedCard === index;
  const {
    setShowDocUploadModal: setShowDocUpload,
    setShowDocUploadModalWeb,
    setTaskName,
    setTrackingItemName,
    clearSelectedFiles
  } = useLipStore(state => state);
  const onHandleDocUpload = useCallback(() => {
    clearSelectedFiles();
    setShowDocUpload(true);
    setShowDocUploadModalWeb(true);
    setTaskName(name);
    setTrackingItemName(trackingItemName);
    logUserEvent({
      action: 'UploadClicked',
      type: 'LIPDocUploadTask',
      description: `Task Section Doc Upload Task ${name}`
    });
  }, [name, setShowDocUpload, setShowDocUploadModalWeb, setTaskName, setTrackingItemName, clearSelectedFiles, trackingItemName]);
  const [isTokenWaiting, setTokenWaiting] = useState(false);
  //@ts-ignore
  const {
    refetchInterval,
    setRefetchInterval,
    loanNumber,
    url,
    authToken,
    handleOnTokenResponse,
    activeDisclosedUserName,
    isEsignUpdating,
    xApiKey,
    esignStatusDetails: {
      infoData,
      errorData,
      isEnabledEsign,
      esignStatusMessage
    }
  } = useContext(ESignContext);
  const [selectedDisclosureUserName, setSelectedDisclosureUserName] = useState('');
  useEffect(() => {
    if (isEsignUpdating) {
      setRefetchInterval(5000);
      const activeUser = activeDisclosedUserName || '';
      isEmpty(selectedDisclosureUserName) ? setSelectedDisclosureUserName(activeUser) : null;
      // setEsignUpdating(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEsignUpdating]);
  const onEsignButtonClick = async () => {
    setSelectedDisclosureUserName(borrowerName);
    setTokenWaiting(true);
    logUserEvent({
      action: 'SignDisclosuresClicked',
      type: 'LIPSignDisclosureTask',
      description: `Task Section Sign Disclosure Task ${borrowerName}`
    });
    await getToken(taskTableData, handleTokenResponse, loanNumber, authToken, url, xApiKey);
    setTokenWaiting(false);
  };
  const docList = useMemo(() => documentList && documentList?.map(({
    documentName,
    createdDate
  }) => ({
    documentName,
    createdDate
  })) || [], [documentList]);
  const handleTokenResponse = useCallback(({
    token,
    url,
    activeDisclosedUserName
  }) => {
    logUserEvent({
      action: 'OpeningDocuTech',
      type: 'ESign'
    });
    handleOnTokenResponse(token, url, activeDisclosedUserName);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [handleOnTokenResponse, logUserEvent]);
  const {
    TASK_UPLOAD_ERROR_MESSAGE
  } = TaskConstants;
  const showTaskUploadWarning = status === TASK_UPLOAD_ERROR_PROBLEM || status === TASK_UPLOAD_ERROR_PRE_GATE_INCOMPLETE || status === TASK_UPLOAD_ERROR_CORRECTION_NEEDED;
  const displayMessage = useMemo(() => {
    return showTaskUploadWarning || esignStatusMessage && taskType === TASK_TYPE_SIGN_DISCLOSURES ? /*#__PURE__*/React.createElement(DocUploadTrackingSnackbar, {
      taskUploadErrorMessage: showTaskUploadWarning ? TASK_UPLOAD_ERROR_MESSAGE : esignStatusMessage,
      infoData: infoData,
      errorData: errorData
    }) : null;
  }, [showTaskUploadWarning, esignStatusMessage, TASK_UPLOAD_ERROR_MESSAGE, infoData, errorData]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableRow
  // eslint-disable-next-line react-native/no-inline-styles
  , {
    style: {
      height: 93,
      backgroundColor: bgColor
    }
  }, /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    sx: {
      borderBottom: 'none'
    }
  }, taskStatus ?
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(Typography, null, /*#__PURE__*/React.createElement(Badge, _extends({
    variant: 'warning',
    fontWeight: 400
  }, badgeStyle[taskStatus], {
    testID: `taskStatus${taskStatus}`,
    accessibilityRole: "text",
    accessibilityLabel: `taskStatus ${taskStatus}`
  }), taskStatus)) : null), /*#__PURE__*/React.createElement(TableCell, {
    sx: {
      borderBottom: 'none'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "regular",
    color: "review.500",
    testID: `borrower-name`,
    accessibilityRole: "text",
    accessibilityLabel: `Borrower Name ${borrowerName}`
  }, borrowerName)), /*#__PURE__*/React.createElement(TableCell, {
    sx: {
      padding: '0.5rem 1rem',
      borderBottom: 'none'
    }
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 1
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: 'center',
    space: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "regularBold",
    testID: `{taskName${name}}`,
    color: "darkGray.900",
    accessibilityRole: "text",
    accessibilityLabel: `taskName ${name}`
  }, name)), /*#__PURE__*/React.createElement(Typography, {
    variant: "regular",
    color: "review.500",
    testID: `taskDetails ${details}`,
    accessibilityRole: "text",
    accessibilityLabel: `taskDetails ${details}`
  }, details), displayMessage)), /*#__PURE__*/React.createElement(TableCell, {
    sx: {
      borderBottom: 'none'
    }
  }, taskType === TASK_TYPE_TRACKING_ITEM ? /*#__PURE__*/React.createElement(HStack, {
    space: 1,
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: "attach-file",
    size: 21,
    color: "blue.900"
  }), /*#__PURE__*/React.createElement(Typography, {
    testID: "documents",
    variant: "caption13",
    color: "darkGray.900",
    accessibilityRole: "text",
    accessibilityLabel: `documents ${documentList?.length}`
  }, documentList && documentList?.length > 0 ? `${documentList.length} files uploaded` : FILES_NONE)) : null), /*#__PURE__*/React.createElement(TableCell, {
    sx: {
      cursor: 'pointer',
      borderBottom: 'none'
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 1,
    alignItems: 'center',
    justifyContent: 'center'
  }, taskType === TASK_TYPE_SIGN_DISCLOSURES ? taskStatus === TASK_STATUS_COMPLETED ? isWaitingforBorrowerESign ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HStack, {
    space: "2",
    alignItems: "center",
    justifyContent: {
      base: 'center',
      md: 'flex-end',
      lg: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: "group",
    size: 20,
    color: "primary.500"
  }), /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "regularBold",
    color: "review.500",
    textTransform: "uppercase",
    testID: "waiting-for-borrower",
    accessibilityRole: "text",
    accessibilityLabel: "Waiting for borrower"
  }, WAITING_FOR_TEXT), /*#__PURE__*/React.createElement(Typography, {
    variant: "regularBold",
    color: "review.500",
    textTransform: "uppercase",
    testID: nonEsignedBorrowerNames,
    accessibilityRole: "text",
    accessibilityLabel: `${nonEsignedBorrowerNames}`
  }, nonEsignedBorrowerNames)))) : null : /*#__PURE__*/React.createElement(React.Fragment, null, selectedDisclosureUserName === borrowerName && (isTokenWaiting || !!refetchInterval) ? /*#__PURE__*/React.createElement(Spinner, {
    accessibilityLabel: "Loading",
    color: "blue.900",
    size: "lg"
  }) : /*#__PURE__*/React.createElement(Button, {
    accessibilityLabel: "signdisclosures",
    accessibilityRole: "button",
    testID: "signdisclosures_button",
    leftIcon: /*#__PURE__*/React.createElement(Iconography, {
      name: "edit",
      size: 21,
      color: "blue.900"
    }),
    variant: 'ghost',
    width: 'auto',
    onPress: onEsignButtonClick,
    isDisabled: !isEnabledEsign
  }, ACTIONS_SIGN_DISCLOSURES)) : /*#__PURE__*/React.createElement(React.Fragment, null, taskStatus === TASK_STATUS_COMPLETED ? null : /*#__PURE__*/React.createElement(Pressable, {
    onPress: onHandleDocUpload
  }, /*#__PURE__*/React.createElement(HStack, {
    space: '1'
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: "upload",
    size: 21,
    color: "blue.900"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "regularBold",
    textTransform: 'uppercase',
    color: "blue.900",
    testID: "upload"
  }, ACTIONS_UPLOAD)))))), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    sx: {
      borderBottom: 'none'
    }
  }, taskType === TASK_TYPE_TRACKING_ITEM ? /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "expand row",
    size: "small",
    onClick: () => handleToggle(index, name)
  }, isOpen ? /*#__PURE__*/React.createElement(Iconography, {
    name: "keyboard-arrow-up",
    size: 25,
    color: "review.500"
  }) : /*#__PURE__*/React.createElement(Iconography, {
    name: "keyboard-arrow-down",
    size: 25,
    color: "review.500"
  })) : null)), Array.isArray(docList) ? /*#__PURE__*/React.createElement(TableRow, null, docList.length > 0 ? /*#__PURE__*/React.createElement(TableCell, {
    sx: {
      backgroundColor: bgColor
    },
    colSpan: 6
  }, /*#__PURE__*/React.createElement(Collapse, {
    in: isOpen,
    timeout: "auto",
    unmountOnExit: true,
    style: {
      paddingTop: 8,
      paddingBottom: 16,
      width: 768,
      margin: 'auto'
    }
  }, /*#__PURE__*/React.createElement(DocumentTable, {
    docTableList: docList
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableCell, {
    sx: {
      backgroundColor: bgColor
    },
    colSpan: 1
  }), /*#__PURE__*/React.createElement(TableCell, {
    sx: {
      backgroundColor: bgColor
    },
    colSpan: 5
  }, /*#__PURE__*/React.createElement(Collapse, {
    in: isOpen,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(Box, {
    paddingY: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption13",
    color: "review.500"
  }, noFilesUploaded)))))) : null);
};
//# sourceMappingURL=index.js.map